import { Link } from 'react-router-dom'
import type { FaelligEintrag as Eintrag } from '../../hooks/uebersichtRegeln'
import s from './FaelligEintrag.module.scss'

/**
 * Ein Eintrag der Spalte Fällig: links wann und Priorität, rechts Typ,
 * Titel und der Fall oder Titel, zu dem es gehört. Überfälliges steht rot.
 */
export function FaelligEintrag({ eintrag }: { eintrag: Eintrag }) {
  return (
    <Link to={eintrag.to} className={s.eintrag}>
      <span className={s.links}>
        <span className={s.wann} data-ueberfaellig={eintrag.ueberfaellig || undefined}>
          {eintrag.wann}
        </span>
        {eintrag.prio && <span className={s.prio}>{eintrag.prio}</span>}
      </span>
      <span className={s.inhalt}>
        <span className={s.typ}>
          <span className={s.punkt} data-neu={eintrag.neu || undefined} aria-hidden="true" />
          {eintrag.typ}
        </span>
        <span className={s.titel}>{eintrag.titel}</span>
        {eintrag.ziel && <span className={s.ziel}>{eintrag.ziel}</span>}
      </span>
    </Link>
  )
}
